import { Crown, Medal, Award, Gem } from "lucide-react";

export const TIER_STYLE = {
  Platinum: { icon: Crown, color: "#E5E4E2", ring: "border-[#E5E4E2]/50" },
  Gold: { icon: Medal, color: "#E0218A", ring: "border-[#E0218A]/60" },
  Silver: { icon: Award, color: "#C0C0C0", ring: "border-[#C0C0C0]/40" },
};
const FALLBACK = { icon: Gem, color: "#FF9A4D", ring: "border-[#FF9A4D]/40" };
export const tierStyle = (t) => TIER_STYLE[t] || FALLBACK;

export const TierBadge = ({ tier, className = "" }) => {
  const s = tierStyle(tier);
  const I = s.icon;
  return (
    <span className={`inline-flex items-center gap-2 font-semibold ${className}`} style={{ color: s.color }}>
      <I className="h-4 w-4" />{tier}
    </span>
  );
};

export const daysUntil = (d) => {
  if (!d) return null;
  const t = new Date(`${d.slice(0, 10)}T00:00:00`);
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return Math.round((t - now) / 86400000);
};

export const DeadlineChip = ({ date, label = "Applications close", testid }) => {
  const n = daysUntil(date);
  if (n === null || n < 0) return null;
  const txt = n === 0 ? `${label} today` : `${label} in ${n} day${n === 1 ? "" : "s"}`;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ${n <= 5 ? "bg-[#E0218A] text-white" : "border border-[#E0218A]/40 text-[#8E2BC4]"}`} data-testid={testid}>
      <span className="h-1.5 w-1.5 rounded-full bg-current animate-pulse" />{txt}
    </span>
  );
};
